import { useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { withState } from '../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../components/common/forms/Title/TitleComponent';
import { API_URL, SVILA_CLIENT_STATUS } from '../../../utils/constants';
import createIcon from '~/src/static/img/createIcon.svg';
import GridWrapper from '~/src/components/common/GridWrapper';

export default function SvilaClientsList(): JSX.Element {
  const stateRef = useRef(null);
  const url = `${API_URL}/svila-clients/get-all`;
  const history = useHistory();
  const StatefullGrid = withState(Grid, url);

  const clientNameCell = (row) => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/svila-clients/edit/${dataItem.id}`}>{dataItem?.name}</Link>
      </td>
    );
  };

  const statusCell = (row) => {
    const { dataItem } = row;
    const status = Object.values(SVILA_CLIENT_STATUS).find((s) => s.value === dataItem.status);
    return <td>{status?.label || 'Unknown'}</td>;
  };

  return (
    <WhitePad>
      <TitleComponent
        title="Svila Clients"
        titleRight="Create"
        onRightHandler={(): void => history.push('/svila-clients/create')}
        iconRight={createIcon}
        titleLeft="Back"
        onLeftHandler={(): void => history.goBack()}
      />
      <GridWrapper>
        <StatefullGrid ref={stateRef}>
          <GridColumn field="name" title="Name" cell={(row) => clientNameCell(row, stateRef)} />
          <GridColumn field="status" title="Status" cell={statusCell} />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}
